<template>
    <div v-bind:class="{'d-none': !showItem}" class="row" style="margin-top: 10px;">
        <div class="col-12">
            <div class="form-group" style="width: 100%;">
                <label :for="item.key">{{ item.label }}</label>
                <input :id="item.key" :name="item.key" :placeholder="item.label" type="number" v-model="itemValue" class="form-control" :min="minVal" :max="maxVal" :step="stepVal" autocomplete="off">
            </div>
        </div>
    </div>
</template>
<script>
    import EventBus from '../../../../EventBus'

    export default {
        props: [
            'item',
            'max',
            'min',
            'step',
            'restaurant'
        ],

        data () {
            return {
                itemValue: null,
                maxVal: this.max,
                minVal: this.min ?? 0,
                stepVal: this.step ?? 1,
                showItem: true
            }
        },

        created() {
            var _this = this;
            EventBus.$on('serviceTypeFormValueUpdated', (data) => {
                if (data.key == 'is_programmed' && _this.item.key == 'numero_persone') {
                    if ((data.value == 'Adesso' || data.value == 'adesso') && _this.item.key == 'numero_persone') {
                        _this.showItem = false;
                    } else {
                        _this.showItem = true;
                    }
                }
            });
        },

        mounted() {
            var _this = this;
            let serviceTypeConfig = this.restaurant.service_type_config;
            if (serviceTypeConfig && serviceTypeConfig.service_type_number) {
                if (serviceTypeConfig.service_type_number.min) {
                    this.minVal = serviceTypeConfig.service_type_number.min;
                }
                if (serviceTypeConfig.service_type_number.max) {
                    this.maxVal = serviceTypeConfig.service_type_number.max;
                }
            }
        },

        watch: {
            itemValue: function(newValue, oldValue) {
                if (typeof this.maxVal !== 'undefined') {
                    if (parseInt(newValue) > parseInt(this.maxVal)) {
                        newValue = Math.min(parseInt(newValue), parseInt(this.maxVal));
                    }
                }
                if (typeof this.minVal !== 'undefined') {
                    if (parseInt(newValue) < parseInt(this.minVal)) {
                        newValue = Math.max(parseInt(newValue), parseInt(this.minVal));
                    }
                }
                this.itemValue = parseInt(newValue);
                EventBus.$emit('serviceTypeFormValueUpdated', {
                    key: this.item.key,
                    value: this.itemValue
                });
            }
        },
    }
</script>
